import React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import Dashboard from './pages/dashboard/Dashboard';
import Transaction from './pages/payment/Transaction/Transaction';
import Transaction2 from './pages/payment/Transaction2/Transaction';
import Login from './pages/auth/Login';
import { AuthProvider } from "./hooks/useAuth";
import ProtectedRoute from './components/ProtectedRoute';
import Coupon from './pages/coupon/Coupon';
import Member from './pages/member/Member';
import Banner from './pages/banner/Banner';
import Affiliate from './pages/affiliate/Member/Affiliate';
import AffiliatePayment from './pages/affiliate/Payment/Payment';
import AffiliateConfig from './pages/affiliate/Config';
import Notification from './pages/notification/Notification';
import CustomerLevelConfig from './pages/member/Config';
import UserCoupon from './pages/coupon/UserCoupon';
import CouponCode from './pages/coupon/CouponCode';
import RewardCategory from './pages/reward/Category';
import Admin from './pages/admin/Admin';
import ActivityLogs from './pages/logs/Activity';
import ConfigReward from './pages/member/ConfigReward';
import ChangePassword from './pages/admin/ChangePassword';
import Topup from './pages/topup/Topup';
import moment from "moment-timezone";

moment.tz.setDefault("UTC");





const routers = [
  {
    path: "/dashboard", element: <Dashboard />
  },
  {
    path: "/payment/transaction", element: <Transaction />
  },
  {
    path: "/payment/transaction2", element: <Transaction2 />
  },
  {
    path: "/affiliate", element: <Affiliate />
  },
  {
    path: "/affiliate/payment", element: <AffiliatePayment />
  },
  {
    path: "/affiliate/config", element: <AffiliateConfig />
  },
  {
    path: "/notification", element: <Notification />
  },
  {
    path: "/member", element: <Member />
  },
  {
    path: "/member/config", element: <CustomerLevelConfig />
  },
  {
    path: "/member/config/reward/:customer_level_id", element: <ConfigReward />
  },
  {
    path: "/topup", element: <Topup />
  },
  {
    path: "/coupon", element: <Coupon />
  },
  {
    path: "/coupon/code/:coupon_id", element: <CouponCode />
  },
  {
    path: "/user_coupon", element: <UserCoupon />
  },
  {
    path: "/banner", element: <Banner />
  },
  {
    path: "/reward/categories", element: <RewardCategory></RewardCategory>
  },
  {
    path: "/admin", element: <Admin />
  },
  {
    path: "/admin/change_password", element: <ChangePassword />
  },
  {
    path: "/logs/activity", element: <ActivityLogs />
  }
]

const Main = () => {
  return (
    <React.StrictMode>
      <BrowserRouter basename="/">
        <AuthProvider>
          {/* <RouterProvider router={router} /> */}
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <App />
                </ProtectedRoute>
              }

            >

              {
                routers.map((item: any, index: number) => {
                  return <Route key={index} path={item.path} element={item.element} />
                })
              }

            </Route>


          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  )
}


ReactDOM.render(<Main />, document.getElementById('root'))


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
